"use client";

import { getDiscoverContextProps } from "@/lib/analytics/discoverContext";
import type { DiscoverTab } from "@/lib/analytics/listingFilters";
import { EMBEDDED_IN_APP_COOKIE } from "@/lib/embeddedInAppCookie";
import Cookies from "js-cookie";
import { useSearchParams } from "next/navigation";

/**
 * Reads being in the app from the cookie when the getter runs, so a view is not
 * reported as web while `EmbeddedInAppContext` loads.
 */
export function useDiscoverContextProps(
  tab: DiscoverTab,
): () => ReturnType<typeof getDiscoverContextProps> {
  const searchParams = useSearchParams();

  return () =>
    getDiscoverContextProps({
      searchParams,
      embeddedInApp: Cookies.get(EMBEDDED_IN_APP_COOKIE) === "true",
      tab,
    });
}
